"use strict";

define('rs/form/formdesigner.controller',['rs/form/form.controller', 'rs/form/formdesigner.view', 'rs/form/section.edit.controller', 'rs/form/formobjects/factory', 'rs/form/attachment.controller', 'rs/form/abstract.form.entity', 'rs/models/document', 'rs/helper', 'e3-modal'], function (FormController, FormDesignerView, SectionEditController, FormObjectFactory, AttachmentController, AbstractFormEntity, Document, helper, E3Modal) {
  var FormDesignerController = FormController.extend({
    properties: ['controlTypes', 'assignmentTypes'],
    controlTypes: [{
      name: 'question',
      label: 'Sub-Section'
    }, {
      name: 'textbox',
      label: 'Text Box'
    }, {
      name: 'radio',
      label: 'Radio Button Group'
    }, {
      name: 'label',
      label: 'Information'
    }, {
      name: 'checkbox',
      label: 'Check Box Group'
    }, {
      name: 'attachment',
      label: 'Attachment'
    }, {
      name: 'datepicker',
      label: 'Date'
    }, {
      name: 'textarea',
      label: 'Text Area'
    }, {
      name: 'personfinder',
      label: 'Person Finder'
    }, {
      name: 'sponsorfinder',
      label: 'Sponsor Finder'
    }],
    newFormObjects: [],
    initialize: function initialize() {
      this._super.apply(this, arguments);
      this.sync('unsavedChanges');
    },
    refreshUnsavedChangesPropertyOnView: function refreshUnsavedChangesPropertyOnView() {
      this.getView().refreshToolbarActions(this.getFormActions());
    },
    getDocumentType: function getDocumentType() {
      return this.getTemplateModel().getDocumentType().toLowerCase();
    },
    getControlTypes: function getControlTypes() {
      var docType = this.getDocumentType(),
        controls = this.get('controlTypes');
      if (docType == "checklist") {
        return _.filter(controls, function (c) {
          return c.name != "sponsorfinder" && c.name != "personfinder";
        });
      } else {
        return controls;
      }
    },
    generateJSON: function generateJSON() {
      return JSON.stringify(this);
    },
    getPersonAssignmentTypes: function getPersonAssignmentTypes() {
      if (!this._personAssignmentCache) {
        var types = this.getAssignmentTypes();
        this._personAssignmentCache = _.filter(types, function (t) {
          return t.finderType == "Person";
        });
      }
      return this._personAssignmentCache;
    },
    updateClientIds: function updateClientIds(ids) {
      var tempIds = this._clientGeneratedIds || [],
        formObjectMap = this.getFormObjectMap(),
        len = ids ? ids.length : 0,
        id = null,
        tempId = null,
        fo = null,
        i = 0;
      for (i = 0; i < len; ++i) {
        id = Number(ids[i]);
        tempId = tempIds[i];
        if (id != null && !_.isNaN(id) && (fo = this.getFormObjectByID(tempId))) {
          fo.setId(id);
          delete formObjectMap[tempId];
          formObjectMap[id] = fo;
          this.checkMaxFormObjectID(fo);
        }
      }
      this._clientGeneratedIds = [];
    },
    saveTemplateData: function saveTemplateData(sync) {
      var that = this;
      return this.getTemplateModel().save(this.generateJSON(), sync).lastly(this.showLoading()).then(function (model) {
        that.setUnsavedChanges(false);
        that.getAppController().navigateTemplate(model, {
          replace: true
        });
        that.updateSectionRoute();
        return model;
      });
    },
    getFormActions: function getFormActions() {
      var section = this.getActiveSection(),
        actions = null;
      actions = [{
        action: 'cancel',
        text: 'Cancel',
        icon: 'ban'
      }, {
        action: 'preview',
        text: 'Preview',
        icon: 'eye'
      }, {
        action: 'save',
        text: 'Save',
        icon: 'hdd-o',
        disabled: !this.getUnsavedChanges()
      }];
      return actions;
    },
    requestCancelAction: function requestCancelAction() {
      var that = this;
      var documentType = this.getDocumentType();
      this.getAppController().navigateTemplateList(documentType, {
        trigger: true
      });
    },
    requestPreviewAction: function requestPreviewAction() {
      var sectionIndex = _.indexOf(this.getSections(), this.getActiveSection());
      var url = this.getAppController().navigateTemplate(this.getTemplateModel(), null, sectionIndex, true, true);
      var ref = location.pathname + '#' + url;
      window.open(ref, '_blank');
      return;
    },
    requestSaveAction: function requestSaveAction() {
      var that = this,
        clientIds = this._clientGeneratedIds || [],
        model = this.getTemplateModel();
      if (clientIds.length) {
        return model.requestNewEFIDs(clientIds.length).then(this.updateClientIds.proxy(this)).then(this.saveTemplateData.proxy(this));
      } else {
        return this.saveTemplateData();
      }
    },
    setupView: function setupView() {
      this.setView(new FormDesignerView());
    },
    viewIsReady: function viewIsReady() {
      var sections = this.getSections();
      if (sections.length == 0) {
        this.newSection();
      }
      this._super.apply(this, arguments);
      this.requestControlsTab();
      AbstractFormEntity.MarkNewlyCreated = true;
    },
    requestPreviousContentController: function requestPreviousContentController() {
      this.requestCancelAction();
    },
    initializeSections: function initializeSections() {
      var template = this.getTemplate() || {},
        sections = template.children || [],
        that = this;
      return _.map(sections, function (section) {
        return that.registerSection(new SectionEditController(section, that));
      });
    },
    newSection: function newSection() {
      var section = null,
        properties = null,
        sections = this.getSections();
      properties = {
        label: "Section " + String(++this.sectionIDCounter),
        text: "Section title",
        id: this.createId(),
        required: true
      };
      section = new SectionEditController(properties, this);
      this.registerSection(section);
      sections.push(section);
      return section;
    },
    newAttachment: function newAttachment() {
      var attachment = null,
        properties = null,
        attachments = this.getAttachments();
      properties = {
        text: 'New Attachment',
        id: this.createId(),
        required: true,
        label: ''
      };
      attachment = new AttachmentController(properties, this);
      attachments.push(attachment);
      this.registerAttachment(attachment);
      return attachment;
    },
    newFormObjectByType: function newFormObjectByType(type, owner, index, noCompound) {
      type = type || 'question';
      var isCompound = FormObjectFactory.isCompoundType(type) && !noCompound && owner.getCompoundType() != type,
        ctor = this.getFormObjectByType(isCompound ? 'question' : type),
        properties = null,
        inst = null;
      index = index || 0;
      if (ctor) {
        properties = {
          label: "",
          text: "",
          type: isCompound ? 'question' : type,
          compoundType: isCompound ? type : undefined,
          id: this.createId()
        };
        inst = new ctor(properties, owner);
        owner.addFormObjectToChildren(inst, index);
        inst.setupFormObject();
        this.registerFormObject(inst);
        if (isCompound) {
          this.newFormObjectByType(type, inst, 0, true);
        }
        this.trackFormEvent('Created a new form object', {
          type: properties.type,
          compoundType: properties.compoundType
        });
      }
    },
    getNewFormObjects: function getNewFormObjects() {
      return this.newFormObjects;
    },
    getFormObjectByType: function getFormObjectByType(type) {
      return FormObjectFactory.getFormObjectByType(type);
    },
    requestPropertiesTab: function requestPropertiesTab() {
      this.getView().activatePropertiesTab();
    },
    requestControlsTab: function requestControlsTab() {
      this.getView().activateControlsTab();
    },
    getActiveFormObject: function getActiveFormObject() {
      var active = this.get('activeFormObject');
      return active || this.getActiveSection();
    },
    getActiveFormObjectTemplateProperties: function getActiveFormObjectTemplateProperties() {
      var active = this.getActiveFormObject(),
        canHaveLinks = active.canHaveLinks(),
        dependencies = active.getDependencies();
      return {
        properties: active.getPropertiesDefinitions(),
        canHaveLinks: canHaveLinks,
        canGoToControl: active.isAttachment !== true,
        links: active.getLinksDefinitions(),
        shouldHideLinks: !canHaveLinks && (!dependencies || dependencies.length == 0),
        dependencies: dependencies
      };
    },
    getDropdownPropertyValueByIndex: function getDropdownPropertyValueByIndex(index, getter, property) {
      var control = this.getActiveFormObject(),
        value = null,
        mapper = 'map' + helper.camelCase(property) + 'PropertyValue';
      if (this.previousFormObject) {
        control = this.previousFormObject;
      }
      if (control && control[getter]) {
        value = control[getter]()[index];
        if (value && control[mapper]) {
          return control[mapper](value);
        }
        return value;
      }
    },
    getFormObjectForPropertiesUpdate: function getFormObjectForPropertiesUpdate() {
      var control = this.getActiveFormObject();
      if (this.previousFormObject) {
        control = this.previousFormObject;
      }
      return control;
    },
    canChangePropertyOnFormObject: function canChangePropertyOnFormObject(fo, property, value) {
      switch (property) {
        case "name":
          if (this.getFormObjectByName(value) || value.match(/\W/g)) {
            return false;
          } else {
            return true;
          }
      }
      return true;
    },
    propertyDidChangeOnActiveFormObject: function propertyDidChangeOnActiveFormObject(property, value) {
      var control = this.getFormObjectForPropertiesUpdate();
      if (this.canChangePropertyOnFormObject(control, property, value)) {
        if (control) {
          var accessor = 'set' + helper.camelCase(property);
          if (control[accessor]) {
            control[accessor](value);
          } else {
            control.set(property, value);
          }
        }
      } else {
        var that = this;
        _.defer(function () {
          that.refreshPropertiesTab();
        });
      }
    },
    triggerRefreshPropertiesTab: function triggerRefreshPropertiesTab() {
      var that = this;
      clearTimeout(this._refreshPropertiesTabTimeout);
      this._refreshPropertiesTabTimeout = setTimeout(function () {
        that.refreshPropertiesTab();
      }, 10);
    },
    refreshPropertiesTab: function refreshPropertiesTab() {
      this.getView().refreshPropertiesTab();
    },
    getTemplateProperties: function getTemplateProperties() {
      return {
        headerTitle: 'Current Sections',
        title: this.getTemplateModel().getTitle(),
        edit: true
      };
    },
    isDesignerMode: function isDesignerMode() {
      return true;
    },
    requestFormObjectActivate: function requestFormObjectActivate(control, noProperties) {
      this.activateFormObject(control, noProperties);
    },
    requestAddSection: function requestAddSection() {
      var section = this.newSection(),
        view = this.getView();
      this.getView().renderNewSection(section);
      section.setup(view.createSectionElement());
      section.setupFormObject();
      this.activateSection(section);
    },
    requestDeleteSection: function requestDeleteSection(section) {
      if (this.getSections().length == 1) {
        E3Modal.BtnMsgModal.show({
          title: 'Warning',
          message: 'You must have at least 1 section.',
          buttons: 'Ok'
        });
      } else {
        section.requestDelete();
      }
    },
    requestDeleteAttachment: function requestDeleteAttachment(attachment) {
      attachment.requestDelete();
    },
    requestAddAttachment: function requestAddAttachment() {
      var attachment = this.newAttachment(),
        view = this.getView(),
        attachEl = this.getView().renderNewAttachment(attachment);
      attachment.setup(attachEl);
      helper.datum(attachEl, attachment.getView());
      attachment.setupFormObject();
      this.requestFormObjectActivate(attachment);
      this.requestPropertiesTab();
    },
    requestSectionOrderByIndex: function requestSectionOrderByIndex(currentIndex, newIndex) {
      var sections = this.getSections(),
        section = sections.splice(currentIndex, 1)[0];
      sections.splice(newIndex, 0, section);
      this.updateSectionRoute();
    },
    activatePreviousFormObject: function activatePreviousFormObject() {
      var active = this.getActiveFormObject(),
        section = this.getActiveSection(),
        children = null,
        index = -1;
      if (section !== active.getSectionController()) {
        this.activateSection(active.getSectionController());
      }
      if (active.section !== true) {
        children = active.getParent().getChildren();
        index = _.indexOf(children, active);
        if (index > 0) {
          this.requestFormObjectActivate(children[index - 1]);
          this.scrollToFormObject(children[index - 1]);
        } else {
          this.requestFormObjectActivate(active.getParent());
          this.scrollToFormObject(active.getParent());
        }
      } else {
        children = active.getChildren();
        if (children.length) {
          this.requestFormObjectActivate(children[children.length - 1]);
          this.scrollToFormObject(children[children.length - 1]);
        }
      }
    },
    activateNextFormObject: function activateNextFormObject() {
      var active = this.getActiveFormObject(),
        section = this.getActiveSection(),
        children = null,
        index = -1;
      if (section !== active.getSectionController()) {
        this.activateSection(active.getSectionController());
      }
      if (active.section !== true) {
        children = active.getParent().getChildren();
        index = _.indexOf(children, active);
        if (index < children.length - 1) {
          this.requestFormObjectActivate(children[index + 1]);
          this.scrollToFormObject(children[index + 1]);
        } else {
          this.requestFormObjectActivate(active.getParent());
          this.scrollToFormObject(active.getParent());
        }
      } else {
        children = active.getChildren();
        if (children.length) {
          this.requestFormObjectActivate(children[0]);
          this.scrollToFormObject(children[0]);
        }
      }
    },
    activateParentFormObject: function activateParentFormObject() {
      var active = this.getActiveFormObject(),
        section = this.getActiveSection(),
        parent = active.getParent();
      if (section !== active.getSectionController()) {
        this.activateSection(active.getSectionController());
      }
      if (active.section !== true && parent) {
        this.requestFormObjectActivate(parent);
        this.scrollToFormObject(parent);
      }
    },
    activateFirstChildFormObject: function activateFirstChildFormObject() {
      var active = this.getActiveFormObject(),
        section = this.getActiveSection(),
        children = active.getChildren();
      if (section !== active.getSectionController()) {
        this.activateSection(active.getSectionController());
      }
      if (children.length) {
        this.requestFormObjectActivate(children[0]);
        this.scrollToFormObject(children[0]);
      }
    },
    requestPropertyListItemRemove: function requestPropertyListItemRemove(propertyName, itemIndex) {
      var activeFormObject = this.getActiveFormObject();
      E3Modal.BtnMsgModal.show({
        title: 'Warning',
        message: 'Are you sure you want to delete this?',
        buttons: ['No', {
          text: 'Yes',
          color: 'danger'
        }]
      }).bind(this).then(function (btn) {
        if (btn == 'Yes') {
          this.currentlyEditing = true;
          activeFormObject.removeItemFromPropertyList(propertyName, itemIndex);
          this.triggerRefreshPropertiesTab();
        }
      });
    },
    activateLabelOnActiveFormObject: function activateLabelOnActiveFormObject() {
      var active = this.getActiveFormObject();
      active.selectLabel();
    },
    activateTextOnActiveFormObject: function activateTextOnActiveFormObject() {
      var active = this.getActiveFormObject();
      active.selectText();
    },
    copyActiveFormObject: function copyActiveFormObject() {
      var active = this.getActiveFormObject();
      if (active.section || active.isAttachment) {
        return;
      }
      this.copiedFormObject = active.toJSON();
    },
    cleanseFormObject: function cleanseFormObject(fo) {
      var children = fo.children || [];
      fo.dataId = this.createId();
      fo.name = null;
      for (var c = 0, len = children.length; c < len; c++) {
        this.cleanseFormObject(children[c]);
      }
      return fo;
    },
    pasteCopiedFormObject: function pasteCopiedFormObject() {
      var active = this.getActiveFormObject(),
        foData = this.cleanseFormObject(this.copiedFormObject),
        parent = active.section ? active : active.getParent(),
        newIndex = _.isNumber(active.rowIndex) ? active.rowIndex + 1 : 0,
        newFormObject = null;
      newFormObject = this.newFormObjectByObject(foData, parent, newIndex);
      this.requestFormObjectActivate(newFormObject);
      this.revealFormObject(newFormObject);
    },
    newFormObjectByObject: function newFormObjectByObject(data, owner, index) {
      var properties = data,
        ctor = this.getFormObjectByType(data.type),
        inst = null;
      inst = new ctor(properties, owner);
      owner.addFormObjectToChildren(inst, index);
      inst.setup();
      this.registerFormObject(inst);
      return inst;
    },
    unlockModels: function unlockModels() {
      return this.getTemplateModel().requestUnlock();
    }
  });
  return FormDesignerController;
});

